import moment from 'moment'

export default function () {
  return {
    accessToken: null,
    refreshToken: null,
    firebaseToken: null,
    lastActivity: moment().utc().unix(),
    isInactive: false,
    profile: null
  }
}
